import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import InstagramIcon from '../assets/sm-icons/IG-WHT.svg';
import LinkedInIcon from '../assets/sm-icons/IN-WHT.svg';
import YouTubeIcon from '../assets/sm-icons/YT-WHT.svg';

const Footer = () => {
    const [footerWidth, setFooterWidth] = useState(0);
    const rowRef = useRef(null);

    useEffect(() => {
        const updateWidth = () => {
            if (rowRef.current) {
                // Calculate width based on the Row's width
                setFooterWidth(rowRef.current.offsetWidth);
            }
        };

        updateWidth();
        window.addEventListener('resize', updateWidth);

        return () => {
            window.removeEventListener('resize', updateWidth);
        };
    }, []);

    return (
        <footer className="footer">
            <div className="sub-footer" style={{ width: '100%' }}>
                <Container>
                    <Row>
                        <Col xs={12} sm={6} className="text-start">
                            {/* Company Name */}
                            <p>2025© Great Place To Work® Institute Inc. All Rights Reserved.</p>
                        </Col>
                        <Col xs={12} sm={4} className="text-center">
                            {/* Imprint/Data Protection Agreement */}
                            <p>
                                <a 
                                    href="https://greatplacetowork.de/impressum/" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="footer-link"
                                >
                                    Impressum
                                </a>
                                <span style={{ margin: '0 10px' }}>|</span>
                                <Link 
                                    to="/datenschutz"
                                    className="footer-link"
                                >
                                    Datenschutz
                                </Link>
                            </p>
                        </Col>
                        <Col xs={12} sm={2} className="text-end">
                            {/* Social Media Icons */}
                            <div style={{ display: 'flex', justifyContent: 'end' }}>
                                <a href="https://www.linkedin.com/company/great-place-to-work-institute-germany/?originalSubdomain=de" target="_blank" rel="noopener noreferrer">
                                    <img src={LinkedInIcon} alt="LinkedIn" style={{ width: '24px', height: '24px', marginRight: '15px' }} />
                                </a>
                                <a href="https://www.youtube.com/channel/UCDWK_SgY8uOG4wZfWBTL1dQ" target="_blank" rel="noopener noreferrer">
                                    <img src={YouTubeIcon} alt="YouTube" style={{ width: '24px', height: '24px', marginRight: '15px' }} />
                                </a>
                                <a href="https://www.instagram.com/gptw_deutschland" target="_blank" rel="noopener noreferrer">
                                    <img src={InstagramIcon} alt="Instagram" style={{ width: '24px', height: '24px' }} />
                                </a>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </footer>
    );
};

export default Footer;